import React from "react"
import { Link } from "gatsby"
import keybordArrow from "../../assets/images/keyboardArrow.svg"
import { useTranslation } from "react-i18next"

const BreadCrumb = ({ items }) => {

  const {t} = useTranslation()
  
  return (
    <nav>
      <ol className="items-center bg-white text-12 font-inter h-10 pl-12 hidden md:flex">
        {items.map((item, index) => (
          <li className="flex items-center">
            {item.url ? (
              <Link
                to={item.url}
                className="text-bcoral font-inter font-normal"
              >
                {t(item.label)}
              </Link>
            ) : (
              <span className="text-dblue font-inter font-medium">
                {t(item.label)}
              </span>
            )}
            {index < items.length - 1 && (
              <img src={keybordArrow} className="p-1" alt=">"></img>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default BreadCrumb
